import React from 'react';
import { CustomModal } from '../CustomModal';
import { Btn } from '../ui';

interface ChangeUnitOfMeasureModalProps {
    visible: boolean;
    oldName: string;
    newName: string;
    affectedCount: number;
    isSaving: boolean;
    error?: string | null;
    onDismiss: () => void;
    onConfirm: () => void;
}

const ChangeUnitOfMeasureModal: React.FC<ChangeUnitOfMeasureModalProps> = ({
    visible,
    oldName,
    newName,
    affectedCount,
    isSaving,
    error,
    onDismiss,
    onConfirm,
}) => {
    const recordWord = affectedCount === 1 ? 'record' : 'records';

    return (
        <CustomModal
            visible={visible}
            header="Change this unit of measure?"
            onDismiss={onDismiss}
            footer={
                <div className="modal-footer-actions">
                    <Btn
                        variant="ghost"
                        buttonText="Cancel"
                        buttonOnClick={onDismiss}
                        buttonDisabled={isSaving}
                    />
                    <Btn
                        variant="warning"
                        buttonText={isSaving ? 'Changing…' : 'Change'}
                        buttonOnClick={onConfirm}
                        buttonDisabled={isSaving}
                    />
                </div>
            }
        >
            <p>
                Changing <strong>{oldName}</strong> to <strong>{newName}</strong> will update every
                equipment record, PM schedule, and service item that uses this unit of measure.
            </p>
            <p>
                {affectedCount} {recordWord} will be updated.
            </p>
            {error && (
                <p className="cr-field-error-text" role="alert">
                    {error}
                </p>
            )}
        </CustomModal>
    );
};

export default ChangeUnitOfMeasureModal;
